/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown> }} Usage_Overage_Used_UncappedInputs */



/**
* | output |
* | --- |
* | "Overage used: {used} this period (no cap)" |
*
* @param {Usage_Overage_Used_UncappedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_used_uncapped = /** @type {((inputs: Usage_Overage_Used_UncappedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Used_UncappedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Überschuss verbraucht: ${i?.used} in diesem Zeitraum (kein Limit)`)
	return /** @type {LocalizedString} */ (`Overage used: ${i?.used} this period (no cap)`)
});